"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWrappedInput = exports.StyledRequiredStar = exports.StyledNotion = exports.StyledField = exports.StyledLabel = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledLabel = styled_components_1.default.label `
  position: absolute;
  top: 2px;
  left: 0;
  display: block;
  padding: 0 12px;

  transition: 0.3s;
  transition-property: top, color, opacity, font-size, line-height;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: ${(props) => (!props.disabled ? 'pointer' : 'default')};

  font-size: 12px;
  line-height: 18px;
  color: #909090;
`;
exports.StyledField = styled_components_1.default.div `
  position: relative;
`;
exports.StyledNotion = styled_components_1.default.div `
  margin: 0 13px;
  font-size: 12px;
  line-height: 18px;
  color: ${(props) => props.hasError ? 'var(--error-color, #e73030)' : '#909090'};
`;
exports.StyledRequiredStar = styled_components_1.default.span `
  position: absolute;
  right: 2px;
  top: 0;
  color: #e73030;
`;
exports.StyledWrappedInput = styled_components_1.default.div `
  & {
    .special-label {
      display: none;
    }

    div.react-tel-input {
      display: flex;
      font-family: inherit;
    }

    div.react-tel-input .form-control {
      display: block;
      box-sizing: border-box;
      padding: 19px 12px 3px 48px;
      width: 100%;
      min-height: 48px;
      border: 1px solid;
      border-color: #ebebeb;
      border-radius: 8px;
      color: #212121;
      font-size: 14px;
      line-height: 20px;
      background: transparent;
      outline: none;
      cursor: pointer;

      &:hover,
      &:focus,
      &:not(:placeholder-shown) {
        border-color: #909090;
      }

      &:disabled {
        border: 1px solid #ebebeb;
        background-color: #ebebeb;
        cursor: default;
      }
    }

    &.error div.react-tel-input .form-control {
      border-color: var(--error-color, #e73030);
    }

    .flag-dropdown {
      order: -1;
      width: 24px;
      height: 16px;
    }

    div.react-tel-input .selected-flag {
      padding-left: 12px;
    }

    div.react-tel-input .flag-dropdown {
      top: 24px;
      background: none;
      border: none;
    }

    div.react-tel-input .selected-flag:hover,
    div.react-tel-input .selected-flag:focus,
    div.react-tel-input .flag-dropdown.open .selected-flag {
      background: transparent;
    }

    div.react-tel-input .flag-dropdown.open {
      background: transparent;
    }

    div.react-tel-input .selected-flag .arrow {
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid
        ${(props) => props.disabled ? '#909090' : 'var(--primary-color, #367bf5)'};
      top: 6px;
    }

    div.react-tel-input .selected-flag .arrow.up {
      border-bottom: 6px solid
        ${(props) => props.disabled ? '#909090' : 'var(--primary-color, #367bf5)'};
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      top: 3px;
    }

    div.react-tel-input .country-list {
      background: #ffffff;
      box-shadow: 0px -4px 8px rgba(138, 118, 92, 0.16);
      border-radius: 8px;
    }

    div.react-tel-input .country-list .country {
      padding: 4px 12px;
    }

    div.react-tel-input .country-list .country:hover {
      background: var(--primary-hover-color);
    }

    div.react-tel-input .country-list .country-name {
      font-size: 16px;
      line-height: 24px;
      color: var(--black);
      margin-right: 6px;
    }

    div.react-tel-input .country-list .country .dial-code {
      font-size: 16px;
      line-height: 24px;
      color: var(--black);
    }
  }
`;
//# sourceMappingURL=input-phone.styled.js.map